export default __webpack_public_path__ + "static/media/ImageryClarity.9d7351b2.png";